import { Button, Modal } from '@melio/penny';
import { FeatureFlags, useFeature } from '@melio/platform-feature-flags';
import { useMelioIntl } from '@melio/platform-i18n';
import { useSubscriptionSuccessModal } from '@melio/subscriptions-sdk';

export const SubscriptionSuccessModal = () => {
  const { formatMessage } = useMelioIntl();
  const modalProps = {
    overflow: 'auto',
  };

  const { successModalProps, hideSuccessModal } = useSubscriptionSuccessModal();

  const onModalClose = () => {
    hideSuccessModal();
    successModalProps?.onClose?.();
  };

  return (
    <Modal
      {...modalProps}
      isOpen={!!successModalProps}
      onClose={onModalClose}
      size="small"
      illustration="celebration"
      data-testid="subscription-success-modal-activity"
      header={formatMessage('activities.subscription.welcomeToPlus.title')}
      description={formatMessage('activities.subscription.welcomeToPlus.description')}
    >
      <Button
        variant="primary"
        label={formatMessage('activities.subscription.welcomeToPlus.goToDashboard')}
        onClick={onModalClose}
        data-testid="subscription-success-modal-activity.primary"
      />
    </Modal>
  );
};

export const SubscriptionSuccessModalActivity = () => {
  const [isPlatformSubscriptionsEnabled] = useFeature(FeatureFlags.PlatformSubscriptions, false);

  if (!isPlatformSubscriptionsEnabled) {
    return null;
  }

  return <SubscriptionSuccessModal />;
};
